module.exports = __webpack_public_path__ + "static/media/userLogo.5e15d525.png";